module.exports = __webpack_public_path__ + "img/arrow-down-pink.3de8b009.svg";